<template>
  <div
    :class="[
      {
        'current-package': item.id === currentPackage.id,
        'package-disable': !item.can_topup && !item.can_subscribe,
      },
      'package',
      {
        'is-recommended': item.is_recommended > 0,
        'have-discount': item.given_days > 0,
      },
      { 'no-discount': item.given_days == 0 },
      {
        'have-time':
          (item.can_topup || item.can_subscribe) && item.is_recommended,
      },
      {
        'margin-bottom-h5':
          (item.can_topup || item.can_subscribe) &&
          item.is_recommended &&
          item.expired_at !== '' &&
          new Date(item.expired_at) > new Date(),
      }
    ]"
    v-if="item.device_count === currentPackage.device_count"
  >
    <div class="best-deal">
      {{ item.is_recommended > 0 ? $t("bestDeal") : "" }}
    </div>
    <div @click="choosePackage" class="package-out">
      <div class="selected-corner" v-if="item.is_recommended > 0">
        <!-- <img src="/static/img/newhome_img/selected_corner.svg" alt="" srcset="" /> -->
        <img src="/static/activityImg/selected_corner.svg" alt="" srcset="" />
      </div>
      <div class="package-pc-info">
        <div class="package-info">
          <div class="off-box">
            <span>{{ item | getDiscount }}</span>
            <span>OFF</span>
          </div>
          <div class="package-name-type">{{ getPackageName(item.name) }}</div>
          <div class="price">
            <p class="price-box">
              <span :class="['price-con', $activity ? 'activity' : '']">{{
                $t(currentSymbol)
              }}</span>
              <span
                :class="[
                  'inner-price',
                  isIE11 ? 'inner-price-ie' : '',
                  $activity ? 'activity' : '',
                ]"
                >{{ item.device_average_price }}</span
              >
            </p>

            <p class="month-device">/{{ $t("month") }}/{{ $t("device") }}</p>
          </div>
        </div>
        <p class="sale-price">
          <span class="origin-price" v-if="item.price !== item.list_price"
            >{{ $t(currentSymbol) }}{{ item.list_price }}</span
          >
          <span> {{ $t(currentSymbol) }}{{ item.price }} </span>
        </p>
        <div class="bottom-box">
          <div class="bottom-btn">
            <template>
              <div
                class="gradient-border-btn"
                :class="
                  !item.can_topup && !item.can_subscribe ? 'disableBtn' : ''
                "
              >
                <!--  v-show="item.id !== currentPackage.id" -->
                <button
                  @click.stop="choosePackage"
                  :class="{
                    'gift-style': item.given_days > 0,
                    is_recommended: item.is_recommended,
                  }"
                >
                  <span :class="{ 'gift-style': item.given_days > 0 }"></span>
                  <span :class="{ 'gift-style': item.given_days > 0 }">
                    <template v-if="item.given_days > 0">{{
                      getGivenMonthsOrDays(item.given_days)
                    }}</template>
                    <template v-else>{{ $t("topUp") }}</template>
                  </span>
                </button>
                <span></span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="package-h5-info">
        <div>
          <div class="package-info">
            <div class="off-box">
              <span>{{ item | getDiscount }}</span>
              <span>OFF</span>
            </div>
          </div>
        </div>
        <div class="package-info-middle">
          <div class="middle-left">
            <div class="package-info">
              <div class="package-name-type">
                {{ getPackageName(item.name) }}
              </div>
            </div>
            <p class="sale-price">
              <span class="origin-price" v-if="item.price !== item.list_price"
                >{{ $t(currentSymbol) }}{{ item.list_price }}</span
              >
              <span> {{ $t(currentSymbol) }}{{ item.price }} </span>
            </p>
            <div class="bottom-box">
              <div class="bottom-btn">
                <template>
                  <div
                    class="gradient-border-btn"
                    :class="
                      !item.can_topup && !item.can_subscribe ? 'disableBtn' : ''
                    "
                  >
                    <!--  v-show="item.id !== currentPackage.id" -->
                    <button
                      @click.stop="choosePackage"
                      :class="{
                        'gift-style': item.given_days > 0,
                        is_recommended: item.is_recommended,
                      }"
                    >
                      <span
                        :class="{ 'gift-style': item.given_days > 0 }"
                      ></span>
                      <span :class="{ 'gift-style': item.given_days > 0 }">
                        <template v-if="item.given_days > 0">{{
                          getGivenMonthsOrDays(item.given_days)
                        }}</template>
                        <template v-else></template>
                      </span>
                    </button>
                    <span></span>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="middle-right">
            <div class="package-info">
              <div class="price">
                <p class="price-box">
                  <span :class="['price-con', $activity ? 'activity' : '']">{{
                    $t(currentSymbol)
                  }}</span>
                  <span
                    :class="[
                      'inner-price',
                      isIE11 ? 'inner-price-ie' : '',
                      $activity ? 'activity' : '',
                    ]"
                    >{{ item.device_average_price }}</span
                  >
                </p>

                <p class="month-device">
                  /{{ $t("month") }}/{{ $t("device") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span v-if="showBuyError" class="choose-package-error">{{
        item.disabled_reason
      }}</span>

      <CountDown
        v-if="(item.can_topup || item.can_subscribe) && item.is_recommended"
        :end-time="item.expired_at"
      />
    </div>
    <img
      v-if="false"
      src="../../../static/img/newhome_img/activity/package_logo_activity.png?99"
      class="package-logo-activity"
    />
  </div>
</template>

<script>
import $ from "jquery";
import { mapState } from "vuex";
import locales from "../dashboard/choosePackage/lang";
import GradientBtn from "../gradientBtn/GradientBtn.vue";
import CountDown from "../../views/home/choosePackage/countDownNew.vue";
export default {
  name: "choosePackage",
  components: {
    GradientBtn,
    CountDown,
  },
  props: {
    item: { type: Object, default: () => {} },
    currentPackage: { type: Object, default: () => {} },
    index: { type: Number, default: () => 0 },
  },
  data: function () {
    return {
      showBuyError: false,
      itemList: [],
      timeee: "",
      isIE11: false,
    };
  },
  locales,
  computed: {
    ...mapState({
      currentSymbol: (state) => state.currentSymbol,
      userCurrentDevice: state => state.user.max_device_count,
    }),
    width() {
      return window.screen.width;
    },
  },
  mounted() {
    this.isIE11 = navigator.userAgent.indexOf("Trident") > -1;
  },
  methods: {
    choosePackage() {
      if (!this.item.can_topup && !this.item.can_subscribe && this.$route.path === '/dashboard') {
        // if (window.innerWidth < 769) {
        //   this.$toast(this.item.disabled_reason);
        // } else {
        //   this.showBug();
        //   this.$store.commit("setCurrentPackage", this.item);
        // }
        this.$store.commit("setCurrentPackage", this.item);
        this.$emit('show-tip', this.item.disabled_reason);
      } else {
        // $('#pay-order').modal('show')
        this.$emit("click-button");
      }
    },
    months(pkg) {
      if (pkg.frequency === "year") {
        return pkg.frequency_interval * 12;
      } else {
        return pkg.frequency_interval;
      }
    },
    getPackageName(name) {
      return name.split("（")[0] || "";
    },
    getGivenMonthsOrDays(days) {
      const months = parseInt(days / 30);
      if (days < 30) {
        return `${
          window.innerWidth < 767 || this.$store.state.currentLang === "en"
            ? this.$tc("new_off_text_day", 0)
            : this.$tc("new_off_text_day", 0)
        } ${days} ${
          days <= 1
            ? this.$tc("new_off_text_day", 1)
            : this.$tc("new_off_text_day", 2)
        }`;
      }
      return `${
        window.innerWidth < 767 || this.$store.state.currentLang === "en"
          ? this.$tc("new_off_text", 0)
          : this.$tc("new_off_text", 0)
      } ${months} ${
        months <= 1 ? this.$tc("new_off_text", 1) : this.$tc("new_off_text", 2)
      }`;
    },
    showBug() {
      if (this.showBuyError) return;
      this.showBuyError = true;
      setTimeout(() => {
        this.showBuyError = false;
      }, 2000);
    },
  },
  filters: {
    getDiscount(pkg) {
      if (pkg.list_price) {
        return (100 - (pkg.price / pkg.list_price) * 100).toFixed(0) + "%";
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
// @import "./packageItem";
// @import '../../../views/home/choosePackage/choosePackage.scss';
.packages-list-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  .package {
    width: 240px;
    min-height: 353px;
    background: transparent;
    border-radius: 8px;
    padding: 0;
    margin-bottom: 30px;
    cursor: pointer;
    transition: all 0.2s;
    .best-deal {
      min-width: 70px;
      min-height: 14px;
      margin: 8px auto;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 14px;
      font-weight: 600;
    }
    .package-out {
      width: 240px;
      min-height: 320px;
      background: #ffffff;
      border: 1px solid rgba(224, 215, 227, 1);
      border-radius: 8px;
      padding: auto;
      position: relative;
      .selected-corner {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 12px;
        left: 12px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .package-info {
        .off-box {
          width: 94px;
          height: 30px;
          line-height: 30px;
          border-radius: 16px;
          background: #e9ebef;
          margin: 24px auto;
          font-size: 16px;
          color: #666666;
          letter-spacing: 0;
          font-weight: 400;
        }
        .package-name-type {
          font-size: 24px;
          color: #333333;
          letter-spacing: 1px;
          line-height: 24px;
          font-weight: 400;
        }
        .price {
          .price-box {
            margin-top: 24px;
            margin-bottom: 8px;
            text-align: center;
            span {
              color: #666666;
              vertical-align: middle;
            }
            .inner-price {
              font-size: 40px;
              letter-spacing: 2.33px;
              line-height: 40px;
              font-weight: 700;
            }
            .price-con {
              font-size: 20px;
              letter-spacing: 1.17px;
              font-weight: 700;
            }
          }
          .month-device {
            font-size: 12px;
            color: #999999;
            letter-spacing: 0;
            text-align: center;
            line-height: 14px;
            font-weight: 400;
            margin-bottom: 16px;
          }
        }
      }
      .sale-price {
        margin-bottom: 24px;
        height: 14px;
        line-height: 14px;
        span {
          font-size: 12px;
          color: #999999;
          letter-spacing: 0;
          font-weight: 400;
        }
        .origin-price {
          text-decoration: line-through;
          margin-right: 16px;
          @media (max-width: 320px) {
            margin-right: 3px;
          }
        }
      }
      .gradient-border-btn {
        button {
          border: 1px solid rgba(224, 215, 227, 1);
          width: 210px;
          height: 40px;
          color: #999999;
          border-radius: 20px;
          font-size: 14px;
          background: #ffffff;
          letter-spacing: 0;
          text-align: center;
        }
      }
      .package-pc-info {
        display: block;
      }
      .package-h5-info {
        display: none;
      }
      // .bottom-box {
      //   display: block;
      // }
    }
  }
  .package:hover {
    margin-top: -10px;
    .gradient-border-btn {
      button {
        color: #ffffff;
        background-image: linear-gradient(97deg, #416CF8 0%, #EC55FF 100%);
      }
    }
  }
  .package.is-recommended {
    padding: 3px;
    padding-top: 0;
    background-image: linear-gradient(136deg, #416CF8 0%, #EC55FF 100%);
    .package-out {
      width: 234px;
      border-color: transparent;
      .package-info {
        .off-box {
          color: #ffffff;
          background-image: linear-gradient(102deg, #416CF8 0%, #EC55FF 100%);
        }
        .price {
          .price-box {
            span {
              color: #111111;
              vertical-align: middle;
            }
          }
          .month-device {
            font-size: 12px;
            color: #999999;
            letter-spacing: 0;
            text-align: center;
            line-height: 14px;
            font-weight: 400;
            margin-bottom: 16px;
          }
        }
      }
    }
    .gradient-border-btn {
      button {
        color: #ffffff;
        background-image: linear-gradient(97deg, #416CF8 0%, #EC55FF 100%);
      }
    }
  }
}
@media (max-width: 1024px) {
  .packages-list-box {
    .package {
      width: 309px;
      min-height: 110px;
      margin-right: 0;
      margin-bottom: 24px;
      .best-deal {
        margin: 0 auto;
        min-height: auto;
      }
      .package-out {
        width: 100%;
        min-height: 110px;
        border-radius: 5px;
        .package-pc-info {
          display: none;
        }
        // .bottom-box {
        //   display: none;
        // }
        .package-h5-info {
          display: block;
        }
        .selected-corner {
          width: 16px;
          height: 16px;
          top: 5px;
          left: 5px;
          img {
            vertical-align: baseline;
          }
        }
        .package-h5-info {
          .package-info {
            position: relative;
            .off-box {
              width: 75px;
              height: 22px;
              border-radius: 16px 5px 0 16px;
              position: absolute;
              top: -1px;
              right: -1px;
              margin: 0;
              font-size: 12px;
              letter-spacing: 0.2px;
              line-height: 22px;
            }
          }
          .package-info-middle {
            padding: 24px 16px 10px 18px;
            padding-top: 24px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            .middle-left {
              text-align: start;
              .package-info {
                .package-name-type {
                  font-size: 18px;
                  letter-spacing: 0.86px;
                  line-height: 24px;
                  margin-bottom: 5px;
                }
              }
              .sale-price {
                margin-bottom: 5px;
                span {
                  font-size: 12px;
                  line-height: 14px;
                }
              }
              .gradient-border-btn {
                height: 14px;
                line-height: 14px;
                button {
                  width: fit-content;
                  height: 14px;
                  border: none;
                  background: none;
                  font-size: .12rem;
                  color: #295ffd;
                  letter-spacing: 0;
                  line-height: .14rem;
                  font-weight: 400;
                  padding: 0;
                }
              }
            }
            .middle-right {
              .package-info {
                .price {
                  .price-box {
                    margin: 0;
                    margin-bottom: 5px;
                    .price-con {
                      font-size: 16px;
                      letter-spacing: 0.93px;
                      line-height: 16px;
                    }
                    .inner-price {
                      font-size: 36px;
                      letter-spacing: 2.1px;
                      line-height: 36px;
                    }
                  }
                  .month-device {
                    margin-bottom: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
    .package.is-recommended {
      min-height: 149px;
      .best-deal {
        margin: 8px auto;
      }
      .package-out {
        width: 100%;
        min-height: 118px;
      }
    }
  }
}
.packages-list-box .package.package-disable {
  &.is-recommended {
    background: #999999;
    .package-out {
      .selected-corner img {
        content: url('/static/img/newhome_img/selected_corner_grey.svg');
      }
      .package-info .off-box {
        background: #999999;
        color: #FFFFFF;
      }
    }
  }
  .gradient-border-btn button {
    background: #999999;
    color: #FFFFFF;
  }
  @media screen and (max-width: 1024px) {
    .package-out .package-h5-info .package-info-middle .middle-left .gradient-border-btn button {
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// packageItemNew.vue?351ed3f3